import * as React from "react";
const SvgPermissions = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="permissions_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path d="M512.486 1023.995h-.495a25.357 25.357 0 0 1-18.422-7.43L235.266 847.94a278.931 278.931 0 0 1-153.59-249.25V215.057a63.28 63.28 0 0 1 42.563-59.869L498.12 3.818a27.132 27.132 0 0 1 27.754 0l373.869 151.37a63.28 63.28 0 0 1 42.575 59.869v383.632a278.931 278.931 0 0 1-153.577 249.187l-258.303 168.626a25.357 25.357 0 0 1-17.94 7.43zM511.99 52.91l-369.38 149.609c-.508.202-1.015.393-1.535.57a12.679 12.679 0 0 0-8.685 12.032V598.69a226.86 226.86 0 0 0 126.787 204.43 22.822 22.822 0 0 1 2.536 1.497l250.277 163.416 250.227-163.416a23 23 0 0 1 2.536-1.496A226.86 226.86 0 0 0 891.54 598.689V215.057a12.679 12.679 0 0 0-8.698-12.032 31.22 31.22 0 0 1-1.521-.57z" />
    <path d="M511.446 516.645A144.664 144.664 0 1 1 656.11 371.98a144.829 144.829 0 0 1-144.664 144.664zm0-238.6a93.95 93.95 0 1 0 93.95 93.936 94.05 94.05 0 0 0-93.95-93.936z" />
    <path d="M513.614 762.928a25.357 25.357 0 0 1-25.357-25.357V489.487a25.357 25.357 0 1 1 50.715 0v248.084a25.357 25.357 0 0 1-25.358 25.357z" />
    <path d="M596.71 597.991h-69.048a25.357 25.357 0 0 1 0-50.714h69.048a25.357 25.357 0 0 1 0 50.714z" />
  </svg>
);
export default SvgPermissions;
